var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttherate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    fill: "white",
    stroke: "#F37B2F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6665 36.0001C28.6665 37.945 29.4391 39.8103 30.8144 41.1855C32.1897 42.5608 34.0549 43.3334 35.9998 43.3334C37.9448 43.3334 39.81 42.5608 41.1853 41.1855C42.5606 39.8103 43.3332 37.945 43.3332 36.0001C43.3332 34.0552 42.5606 32.1899 41.1853 30.8146C39.81 29.4394 37.9448 28.6667 35.9998 28.6667C34.0549 28.6667 32.1897 29.4394 30.8144 30.8146C29.4391 32.1899 28.6665 34.0552 28.6665 36.0001Z",
    stroke: "#F37B2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 36V38.75C43.3333 39.9655 43.8162 41.1313 44.6758 41.9909C45.5353 42.8504 46.7011 43.3333 47.9167 43.3333C49.1322 43.3333 50.298 42.8504 51.1576 41.9909C52.0171 41.1313 52.5 39.9655 52.5 38.75V36C52.5046 32.4545 51.367 29.0018 49.2557 26.1535C47.1445 23.3051 44.1719 21.2126 40.7784 20.1858C37.3848 19.159 33.7508 19.2527 30.4146 20.4529C27.0785 21.653 24.2176 23.8959 22.2559 26.8492C20.2941 29.8025 19.3359 33.3092 19.523 36.8497C19.7102 40.3902 21.0328 43.7763 23.2949 46.5064C25.5571 49.2364 28.6384 51.1652 32.0825 52.007C35.5266 52.8487 39.1503 52.5588 42.4167 51.18",
    stroke: "#F37B2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttherate);
export default __webpack_public_path__ + "static/media/attherate.96abdf869e59cab5296b6da4c94daea3.svg";
export { ForwardRef as ReactComponent };